export default __webpack_public_path__ + "static/media/img8.c176bfef.png";